import { useEffect } from 'react';

declare global {
  interface Window {
    /**
     * Read by the prerender service (securspace-aws#20). index.html sets it to
     * false before any script runs; a page flips it to true once the data its
     * SEO tags depend on has resolved, and prerender snapshots the DOM then
     * instead of guessing from network idleness.
     */
    prerenderReady?: boolean;
  }
}

/**
 * Publish whether this route's SEO-relevant data has finished loading.
 * Pass the same condition that gates rendering the real <title>/<meta>/JSON-LD.
 * Resets to false on unmount so the next route starts "not ready".
 */
export function usePrerenderReady(ready: boolean): void {
  useEffect(() => {
    window.prerenderReady = ready;
    return () => {
      window.prerenderReady = false;
    };
  }, [ready]);
}
